import script from "./CountUp.vue?vue&type=script&setup=true&lang=js"
export * from "./CountUp.vue?vue&type=script&setup=true&lang=js"

import "./CountUp.vue?vue&type=style&index=0&id=39ba37ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ba37ab"]])

export default __exports__